<script>
export default {
    openPop: function(popId, title, width, height, hideMaxmin, colseCB, body, conf = {}){
        body = body ? $(body) : $(".layui-body");
        var w = width ? width : (body.width() * 0.3);
        var h = height ? height : (body.height() * 0.6);
        var top = Number(body.css("top").substring(0,body.css("top").indexOf("px")));
        var config = {
            type: 1,
            fix: false, //不固定
            maxmin: hideMaxmin ? false : true,
            shadeClose: true,
            area: [w + 'px', h + 'px'],
            shade: 0.4,
            title: title,
            content: $("#" + popId),
            // body: body
            targetEl: body,
            ...conf
        }
        if(colseCB) {
            config.cancel =  colseCB;
        }
        layui.layer.open(config);
    },
    openConfigPop: function(config){
        var w = config.width ? config.width : ($(".layui-body").width() * 0.3);
        var h = config.height ? config.height : ($(".layui-body").height() * 0.6);
        var top = Number($(".layui-body").css("top").substring(0,$(".layui-body").css("top").indexOf("px")));
        var popConfig = {
            type: 1,
            targetEl: config.targetEl,
            fix: false, //不固定
            maxmin: config.hideMaxmin ? false : true,
            shadeClose: !!config.shadeClose,
            offset: [top + 20, 0],
            area: [w + 'px', h + 'px'],
            shade: 0.4,
            title: config.title,
            content: $("#" + config.popId),
        }
        if(config.colseCB) {
            popConfig.cancel =  config.colseCB;
        }
        layui.layer.open(popConfig);
    },
    openConfigPopRight: function(config){
        var width = config.width ? config.width : '400px';
        var height = config.height ? config.height : '97%';
        layui.layer.open({
            anim: -1, // 不启用动画
            type: 1,
            content: $("#" + config.popId),
            title: !1,
            closeBtn: !1,
            fix: false, //不固定
            offset: "r",
            shade: .1,
            shadeClose: true,
            targetEl: config.targetEl,
            skin: "layui-anim layui-anim-rl layui-layer-adminRight",
            area: [width, height]
        })
    },
    openWin: function(popId, title,colseCB,body, conf = {}){
        body = body ? body : $(".layui-body");
        var top = Number(body.css("top").substring(0,body.css("top").indexOf("px")));
        let w = body.width();
        let h = body.height();
        var config = {
            type: 1,
            area: [w + 'px', h + 'px'],
            offset: [top, 0],
            fix: true, //不固定
            maxmin: false,
            shadeClose: true,
            shade: 0,
            title: title,
            content: $("#" + popId),
            targetEl: body,
            ...conf
        };
        if(colseCB) {
            config.cancel = colseCB;
        }
        layui.layer.open(config);
    },
    openPopRight: function(popId,width,height,colseCB,body, title){
        body = body ? body : $(".layui-body");
        width = width ? width : '400px';
        height = height ? height : '94%';
        let config = {
            anim: -1, // 不启用动画
            type: 1,
            content: $("#" + popId),
            fix: false, //不固定
            offset: "r",
            shade: .1,
            title: title,
            skin: "layui-anim layui-anim-rl layui-layer-adminRight",
            area: [width, height],
            targetEl: body
        }
        if(colseCB) {
            config.cancel = colseCB;
        }
        layui.layer.open(config)
    },
    closePop: function(popId) {
        try {
          let layerid = $('#' + popId).parents('.layui-layer-page').attr('id');
          layui.layer.close(layerid.substring(11));
        } catch (e) {
            console.error(e);
        }
        $('#' + popId).parents('.layui-layer').find('.layui-layer-close').trigger('click');
    },
    /**
     *
     * @param {*} content
     * @param {*} isFriendly
     * @param {*} time 指定时间后alert自动关闭
     */
    openAlert(content, isFriendly, time, conf) {
        //isFriendly成功标志
        var index;
        if (isFriendly) {
            index = layui.layer.alert(content, {icon: 6, ...conf});
        } else {
            index = layui.layer.alert(content, {icon: 5, ...conf});
        }
        if(time) {
            setTimeout(()=>{
                layui.layer.close(index);
            }, time);
        }
    },
    openSuccess(content, conf) {
        this.openAlert(content, true, undefined, conf);
    },
    openMsg(content, config){
        layui.layer.msg(content, config);
    },

    openConfirm(content, yes_callback, no_callback, conf={}){
        layui.layer.confirm(content,
            {
                btn: ['确定', '取消'],
                targetEl: conf.targetEl ? conf.targetEl : $('.layadmin-tabsbody-item').children()[0],
                btn1: function(index){
                    if (yes_callback) {
                        yes_callback();
                    }
                    layui.layer.close(index);
                },
                btn2: function(index,layero){
                    if (no_callback) {
                        no_callback();
                    }
                },
                cancel: function(){
                  if (no_callback) {
                    no_callback();
                  }
                },
                ...conf,
            });
    },
    showLoading(options) {
        layui.layer.load(3, options);
    },
    closeLoading() {
       layui.layer.closeAll('loading');
    },
    tips(title, elem, tipConfig){
        return layui.layer.tips(title, elem, tipConfig ? tipConfig : {tips: [1, '#5FB878']})
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiLayer.vue